import { render, staticRenderFns } from "./StepEventSettings.vue?vue&type=template&id=137d065e&"
import script from "./StepEventSettings.vue?vue&type=script&lang=js&"
export * from "./StepEventSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports